import React, { useState, useEffect } from 'react';

const FONT = '"Nunito","Baloo 2",sans-serif';

export default function SentenceBuilderGame({ payload, onAnswer, disabled }) {
  const correct = payload.tokens_correct || (payload.sentence || '').split(' ');
  const initialPool = (payload.tokens_shuffled || correct.slice());
  const [pool, setPool] = useState([]);
  const [picked, setPicked] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    setPool(initialPool.map((t, i) => ({ id: `t${i}-${t}`, text: t })));
    setPicked([]);
    setSubmitted(false);
  }, [payload]);

  const move = (token, fromPool) => {
    if (submitted || disabled) return;
    if (fromPool) {
      setPool((p) => p.filter((x) => x.id !== token.id));
      setPicked((p) => [...p, token]);
    } else {
      setPicked((p) => p.filter((x) => x.id !== token.id));
      setPool((p) => [...p, token]);
    }
  };

  const submit = () => {
    if (submitted) return;
    const built = picked.map((t) => t.text).join(' ');
    const target = correct.join(' ');
    setSubmitted(true);
    if (onAnswer) onAnswer({
      is_correct: built === target,
      user_answer: built,
    });
  };

  const reset = () => {
    if (submitted) return;
    setPool(initialPool.map((t, i) => ({ id: `t${i}-${t}`, text: t })));
    setPicked([]);
  };

  const builtText = picked.map((t) => t.text).join(' ');
  const target = correct.join(' ');
  const ok = submitted && builtText === target;

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', fontFamily: FONT }}>
      {/* Built sentence area */}
      <div
        style={{
          minHeight: 80,
          padding: 14,
          background: '#fff',
          border: '2px dashed #1e40af',
          borderRadius: 14,
          marginBottom: 12,
          display: 'flex',
          flexWrap: 'wrap',
          gap: 8,
          alignItems: 'flex-start',
        }}
      >
        {picked.length === 0 ? (
          <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>
            Bấm vào từ bên dưới để xếp câu...
          </span>
        ) : (
          picked.map((t) => (
            <button key={t.id} onClick={() => move(t, false)} style={chip('#1e40af', '#fff')}>
              {t.text}
            </button>
          ))
        )}
      </div>

      {/* Pool area */}
      <div
        style={{
          minHeight: 60,
          padding: 14,
          background: '#f3f4f6',
          borderRadius: 14,
          display: 'flex',
          flexWrap: 'wrap',
          gap: 8,
        }}
      >
        {pool.map((t) => (
          <button key={t.id} onClick={() => move(t, true)} style={chip('#fff', '#1e3a8a')}>
            {t.text}
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 10, marginTop: 14, justifyContent: 'center' }}>
        <button onClick={reset} disabled={submitted || disabled} style={btn('#6b7280')}>
          Làm lại
        </button>
        <button
          onClick={submit}
          disabled={submitted || disabled || pool.length > 0}
          style={btn('#1e40af')}
        >
          Kiểm tra
        </button>
      </div>

      {submitted ? (
        <div style={{ marginTop: 14, padding: 12, background: '#f3f4f6', borderRadius: 10 }}>
          <div style={{ fontWeight: 700, color: ok ? '#065f46' : '#991b1b' }}>
            {ok ? '🎉 Đúng câu rồi!' : '😬 Chưa đúng'}
          </div>
          <div style={{ marginTop: 4, color: '#374151' }}>
            Câu đúng: <em>"{target}"</em>
          </div>
          {payload.translation_vi ? (
            <div style={{ marginTop: 4, color: '#6b7280', fontStyle: 'italic' }}>
              ({payload.translation_vi})
            </div>
          ) : null}
          {payload.explanation_vi ? (
            <div style={{ marginTop: 6, color: '#374151' }}>{payload.explanation_vi}</div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

function chip(bg, color) {
  return {
    padding: '8px 14px',
    background: bg,
    color,
    border: bg === '#fff' ? '2px solid #c7d2fe' : 'none',
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: FONT,
  };
}

function btn(bg) {
  return {
    padding: '10px 22px',
    background: bg,
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 700,
    cursor: 'pointer',
  };
}
